<header mat-dialog-title>
    <div class="header-title-content">
        <span *ngIf="timeslots">Modifica orario che ha inizio: {{ timeslots.start_time }} </span>
        <span *ngIf="!timeslots" class="new-item">Nuovo orario di apertura</span>
    </div>

    <div class="header-actions" *ngIf="timeslots">
        <button mat-icon-button [mat-menu-trigger-for]="actionMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu x-position="before" overlapTrigger="false" #actionMenu="matMenu">
          <button mat-menu-item (click)="deleteTimeSlot()">
            <mat-icon>delete</mat-icon>
            Elimina orario di apertura
          </button>
        </mat-menu>
    </div>
</header>

<mat-dialog-content>
    <form [formGroup]="timeslotsForm" novalidate>
        <div class="u-flex-full">
            <mat-form-field class="u-full-width">
                <mat-label>Orario Inizio</mat-label>
                <input matInput type="time" formControlName="start_time" placeholder="Ad esempio: 15:00" />
                <mat-error *ngIf="timeslotsForm.get('start_time').hasError('required')">
                    Campo obbligatorio
                </mat-error>
                <!-- <mat-error *ngIf="timeslotsForm.get('start_time').hasError('pattern')">
                    Formato orario errato
                </mat-error> -->
            </mat-form-field>
            
            <mat-form-field class="u-full-width">
                <mat-label>Orario Fine</mat-label>
                <input matInput type="time" formControlName="end_time" placeholder="Ad esempio: 23:00" />
                <mat-error *ngIf="timeslotsForm.get('end_time').hasError('required')">
                    Campo obbligatorio
                </mat-error>
                <!-- <mat-error *ngIf="timeslotsForm.get('end_time').hasError('pattern')">
                    Formato orario errato
                </mat-error> -->
            </mat-form-field>          

        </div>

        <div class="u-flex-full">
            <mat-slide-toggle formControlName="active" color="primary">
                Attivo
            </mat-slide-toggle>

            <mat-form-field class="u-full-width">
                <mat-label>Giorno della settimana</mat-label>
                <mat-select formControlName="day_of_week" required>
                    <mat-option [value]="1">Lunedì</mat-option>
                    <mat-option [value]="2">Martedì</mat-option>
                    <mat-option [value]="3">Mercoledì</mat-option>
                    <mat-option [value]="4">Giovedì</mat-option>
                    <mat-option [value]="5">Venerdì</mat-option>
                    <mat-option [value]="6">Sabato</mat-option>
                    <mat-option [value]="7">Domenica</mat-option>
                </mat-select>
                <mat-error>Campo obbligatorio</mat-error>
            </mat-form-field>
              
        </div>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="left-actions">
        <button mat-raised-button (click)="revert()" [disabled]="timeslotsForm.pristine">
            Reset
        </button>
        <button mat-raised-button color="primary" (click)="save()" [disabled]="timeslotsForm.pristine || !timeslotsForm.valid">
            Salva
        </button>
        <!-- <mat-error class="time-error-message" *ngIf="timeslotsForm.hasError('timeError')">
            L'orario di fine deve essere dopo l'orario di inizio.
        </mat-error> -->
    </div>
    <div class="right-actions">
        <button mat-raised-button (click)="close()">
            Chiudi
        </button>
    </div>
</mat-dialog-actions>